import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationCL from "../locales/es-CL/translation.json";
import translationPE from "../locales/es-PE/translation.json";
import { getCookie } from "../services/cookies";


const cookieCountryCode = getCookie('country_code');

const resources = {
  cl: {
    translation: translationCL,
  },
  pe: {
    translation: translationPE,
  },
};


i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'cl',
    lng: `${ cookieCountryCode === 'CL' ? 'cl' : 'pe' }`,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });


export default i18n;